import { render } from "./formApplicationItzai.vue?vue&type=template&id=a4190852&scoped=true"
import script from "./formApplicationItzai.vue?vue&type=script&lang=js"
export * from "./formApplicationItzai.vue?vue&type=script&lang=js"

import "./formApplicationItzai.vue?vue&type=style&index=0&id=a4190852&scoped=true&lang=css"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4190852"]])

export default __exports__